/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EligibilityRuleDto } from './EligibilityRuleDto';
import {
    EligibilityRuleDtoFromJSON,
    EligibilityRuleDtoFromJSONTyped,
    EligibilityRuleDtoToJSON,
    EligibilityRuleDtoToJSONTyped,
} from './EligibilityRuleDto';
import type { QuestionDto } from './QuestionDto';
import {
    QuestionDtoFromJSON,
    QuestionDtoFromJSONTyped,
    QuestionDtoToJSON,
    QuestionDtoToJSONTyped,
} from './QuestionDto';

/**
 * 
 * @export
 * @interface SurveyQuestionsResponse
 */
export interface SurveyQuestionsResponse {
    /**
     * Survey ID
     * @type {string}
     * @memberof SurveyQuestionsResponse
     */
    surveyId?: string;
    /**
     * Survey name
     * @type {string}
     * @memberof SurveyQuestionsResponse
     */
    surveyName?: string;
    /**
     * List of questions in the survey
     * @type {Array<QuestionDto>}
     * @memberof SurveyQuestionsResponse
     */
    questions?: Array<QuestionDto>;
    /**
     * Total number of questions
     * @type {number}
     * @memberof SurveyQuestionsResponse
     */
    totalQuestions?: number;
    /**
     * Eligibility rules of the survey, ordered by priority (empty when none)
     * @type {Array<EligibilityRuleDto>}
     * @memberof SurveyQuestionsResponse
     */
    eligibilityRules?: Array<EligibilityRuleDto>;
}

/**
 * Check if a given object implements the SurveyQuestionsResponse interface.
 */
export function instanceOfSurveyQuestionsResponse(value: object): value is SurveyQuestionsResponse {
    return true;
}

export function SurveyQuestionsResponseFromJSON(json: any): SurveyQuestionsResponse {
    return SurveyQuestionsResponseFromJSONTyped(json, false);
}

export function SurveyQuestionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyQuestionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'surveyId': json['surveyId'] == null ? undefined : json['surveyId'],
        'surveyName': json['surveyName'] == null ? undefined : json['surveyName'],
        'questions': json['questions'] == null ? undefined : ((json['questions'] as Array<any>).map(QuestionDtoFromJSON)),
        'totalQuestions': json['totalQuestions'] == null ? undefined : json['totalQuestions'],
        'eligibilityRules': json['eligibilityRules'] == null ? undefined : ((json['eligibilityRules'] as Array<any>).map(EligibilityRuleDtoFromJSON)),
    };
}

export function SurveyQuestionsResponseToJSON(json: any): SurveyQuestionsResponse {
    return SurveyQuestionsResponseToJSONTyped(json, false);
}

export function SurveyQuestionsResponseToJSONTyped(value?: SurveyQuestionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'surveyId': value['surveyId'],
        'surveyName': value['surveyName'],
        'questions': value['questions'] == null ? undefined : ((value['questions'] as Array<any>).map(QuestionDtoToJSON)),
        'totalQuestions': value['totalQuestions'],
        'eligibilityRules': value['eligibilityRules'] == null ? undefined : ((value['eligibilityRules'] as Array<any>).map(EligibilityRuleDtoToJSON)),
    };
}

